import clsx from 'clsx';
import { format } from 'date-fns';
import mergeClasses from '../../../../utils/shallowMerge';
import { Link } from '../../../atoms/link/Link';
import { Text } from '../../../typography/text/Text';
import Media from '../../media';
import { formatUrl } from '../utils';
import { theme } from './_vars';
import defaultClasses from './ArticleTile.module.scss';

interface Category {
  url?: string;
  title?: string;
}

interface ArticleTileProps {
  thumbnail: any;
  title?: string;
  isSSR?: boolean;
  shortDescription?: string;
  url: string;
  publishDate: string | Date;
  className?: string;
  customClasses?: Record<string, string>;
  isWrapperMedia?: boolean;
  categories?: Category[];
  inGrid?: boolean;
}

const ArticleTile: React.FC<ArticleTileProps> = ({
  thumbnail,
  title,
  isSSR = false,
  shortDescription,
  url,
  publishDate,
  className,
  customClasses = {},
  isWrapperMedia = false,
  categories,
  inGrid = false,
}) => {
  const formattedDate = format(new Date(publishDate), 'd MMM yyyy');
  const styles = mergeClasses(defaultClasses, customClasses);

  const category = categories?.[0];

  const renderSectionName = () => {
    if (!(category?.url && category?.title)) return null;

    return (
      <>
         | 
        <Link className={styles.sectionName} link={formatUrl(category?.url)}>
          <span>{category.title}</span>
        </Link>
      </>
    );
  };

  return (
    <div
      className={clsx(defaultClasses.container, className, {
        [styles.inGrid]: inGrid,
      })}
    >
      <Link className={styles.mediaBlock} link={formatUrl(url)}>
        <Media
          media={thumbnail}
          isSSR={isSSR}
          wrappedContent={isWrapperMedia}
          customClasses={undefined}
          showControls={undefined}
        />
      </Link>
      <div className={styles.content}>
        {title && (
          <Link link={formatUrl(url)}>
            <Text as="h3" size="lg" className={styles.title}>
              {title}
            </Text>
          </Link>
        )}
        {theme === 'sportscraft' && (
          <span className={styles.publishDate}>
            {formattedDate}
            {renderSectionName()}
          </span>
        )}
        {shortDescription && (
          <Text as="p" size="sm" className={clsx(styles.description, styles.articleDescription)}>
            {shortDescription}
          </Text>
        )}
        <div className={clsx(styles.bottomBlock, styles.bottom)}>
          {theme !== 'sportscraft' && (
            <span className={styles.publishDate}>
              {formattedDate}
              {renderSectionName()}
            </span>
          )}
          <Link link={formatUrl(url)} className={styles.readMore}>
            Read more
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ArticleTile;
